module.exports = __webpack_public_path__ + "static/media/kn.37575b90.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kn.svg
// module id = 2132
// module chunks = 0